module.exports = __webpack_public_path__ + "img/teacher5.0ac408ee.webp";